import activity from './activity.json';
import apiactivity from './api-activity.json';
import appDownload from './appDownload.json';
import assetshistory from './assets-history.json';
import assets from './assets.json';
import auth from './auth.json';
import buycryptos from './buy-cryptos.json';
import components from './components.json';
import download from './download.json';
import financial from './financial.json';
import forbidden from './forbidden.json';
import hashBrokerage from './hashBrokerage.json';
import hashkeyPro from './hashkeyPro.json';
import home from './home.json';
import hsk from './hsk.json';
import hskFee from './hskFee.json';
import hskPoints from './hskPoints.json';
import jsbridge from './jsbridge.json';
import kyc from './kyc.json';
import limitedTimeWelcome from './limitedTimeWelcome.json';
import login from './login.json';
import markets from './markets.json';
import messagecenter from './message-center.json';
import noRouter from './noRouter.json';
import nps from './nps.json';
import officialverification from './official-verification.json';
import order from './order.json';
import otherSrc from './otherSrc.json';
import price from './price.json';
import recharge from './recharge.json';
import register from './register.json';
import resetpassword from './reset-password.json';
import reverseCustomerAcquisition from './reverseCustomerAcquisition.json';
import rfq from './rfq.json';
import safeWay from './safeWay.json';
import spot from './spot.json';
import tokeninfo from './token-info.json';
import tradeGiveHsk from './tradeGiveHsk.json';
import tradeHsk from './tradeHsk.json';
import user from './user.json';
import withdrawal from './withdrawal.json';
import tdk from './tdk.json';
import newPrice from './newPrice.json';
import profit from './profit.json';
import glossary from './glossary.json';
import howToBuy from './howToBuy.json';
import calculator from './calculator.json';
import blog from './blog.json';
import dca from './dca.json';
    
const locales = { ...activity, ...apiactivity, ...appDownload, ...assetshistory, ...assets, ...auth, ...buycryptos, ...download, ...forbidden, ...hashBrokerage, ...home, ...hsk, ...hskFee, ...hskPoints, ...jsbridge, ...limitedTimeWelcome, ...login, ...markets, ...messagecenter, ...noRouter, ...officialverification, ...order, ...otherSrc, ...price, ...recharge, ...register, ...resetpassword, ...reverseCustomerAcquisition, ...safeWay, ...spot, ...tokeninfo, ...tradeHsk, ...user, ...withdrawal, ...rfq, ...tradeGiveHsk, ...kyc, ...hashkeyPro, ...financial, ...nps, ...tdk, ...components, ...profit, ...glossary, ...howToBuy, ...calculator, ...newPrice, ...blog, ...dca };

export default locales;

